import _ from 'lodash';
import useTableTypes from '../../useProgressionTable/useTableTypes';
import LineLoader from '../LineLoader';
import ButtonListToggler from 'components/base/ButtonListToggler';

const TableTypeToggler = ({ tableType, onChange }) => {
  const { tableTypes, isLoading } = useTableTypes();
  const buttonList = _.map(tableTypes, currType => ({
    name: currType.name,
    value: currType.key,
    tableType: currType
  }));

  if (isLoading) return <LineLoader />;

  return (
    <div data-cy='resource-type-toggler'>
      <ButtonListToggler
        list={buttonList}
        value={tableType?.key}
        onChange={option => onChange(option.tableType)}
        max={5}
      />
    </div>
  );
};

export default TableTypeToggler;
